var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{staticClass:"card--grid-nav",attrs:{"href":_vm.href}},[_c('img',{staticClass:"grid-nav__image",attrs:{"src":_vm.image}}),_c('h4',{staticClass:"grid-nav__title"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }